import styled from '@emotion/native';

export const Spacer = styled.View<{ w?: number; h?: number; }>`
  ${(props) => props?.h && `
    width: 100%;
    height: ${12 * props?.h}px;
  `}
  ${(props) => props?.w && `
    width: ${12 * props?.w}px;
  `}
`;

export const Line = styled.View`
    background-color: #000;
    opacity: 0.11;
    bottom: 0;
    margin: auto;

    margin-top: ${({ h = 0 }: any) => `${12 * h}px`};
    margin-bottom: ${({ h = 0 }: any) => `${12 * h}px`};

    height: 1px;
    width: 100%;
`;

export const Row = styled.View<{ justification?: string; alignment?: string }>`
    display: flex;
    ${props => `justify-content: ${props.justification || "space-between"};`}
    ${props => `align-items: ${props.alignment || "flex-start"};`}
    flex-direction: row;

    flex-wrap: wrap;
    width: 100%;
`;

export const Column = styled.View`
    display:flex;
    flex-direction: column;
    flex-basis: 1000%;
    flex: 1;
    justify-content: center;
`;


export const Icon = styled.Image`
    width: 36px;
    height: 36px;
`;